import axios from 'axios';
import { ApiConfig } from '../constants/apiConfig';
import { guruAuthorizationHeaders } from './authService';

const guruUrl = (path) => `${ApiConfig.baseUrl}/guru${path}`;

const request = async (method, path, data, params) => {
  const response = await axios({
    method,
    url: guruUrl(path),
    data,
    params,
    headers: guruAuthorizationHeaders(),
  });
  if (response.data?.success === false) {
    throw new Error(response.data.message || 'Permintaan gagal.');
  }
  return response.data;
};

export const fetchGuruDashboard = async () =>
  (await request('get', '/dashboard')).data || {};

export const fetchGuruStudents = async (search = '') => {
  const students = [];
  let page = 1;
  let lastPage = 1;
  do {
    const response = await request('get', '/siswa', undefined, { search, per_page: 100, page });
    students.push(...(response.data?.data || []));
    lastPage = response.data?.last_page || 1;
    page += 1;
  } while (page <= lastPage);
  return students;
};

export const fetchStudentActivity = async (studentId, month) =>
  (await request('get', `/siswa/${studentId}/aktivitas`, undefined, { month })).data || {};

export const fetchGuruPermits = async (status = 'menunggu', page = 1, search = '') => {
  const response = await request('get', '/izin', undefined, { status, page, search });
  return response.data;
};

export const fetchGuruPermitPhoto = async (permitId) => {
  const response = await axios.get(guruUrl(`/izin/${permitId}/foto`), {
    responseType: 'blob',
    headers: guruAuthorizationHeaders(),
  });
  return response.data;
};

export const decideGuruPermit = async (permitId, status) =>
  request('patch', `/izin/${permitId}`, { status });

export const fetchGuruJournals = async (kind = 'harian', status = 'menunggu', page = 1, search = '') => {
  const response = await request('get', `/jurnal/${kind}`, undefined, { status, page, search });
  return response.data;
};

export const decideGuruJournal = async (kind, journalId, status, catatanRevisi = '') =>
  request('patch', `/jurnal/${kind}/${journalId}`, {
    status,
    ...(status === 'perlu_revisi' ? { catatan_revisi: catatanRevisi } : {}),
  });

export const resetStudentPassword = async (studentId) =>
  request('post', `/siswa/${studentId}/reset-password`);

export const resetStudentSchedule = async (studentId) =>
  request('post', `/siswa/${studentId}/reset-jadwal`);

export const moveStudentDevice = async (studentId) =>
  request('post', `/siswa/${studentId}/move-device`);

export const changeGuruPassword = async (currentPassword, newPassword) =>
  request('patch', '/password', {
    current_password: currentPassword,
    new_password: newPassword,
    new_password_confirmation: newPassword,
  });
